function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getContentValues } from '@truqc/content-path';
import { evaluateSource } from '../../behaviors/src/lib/evaluateSource';

/**
  * @function evalute - evaluate csvImportGetUnselectedMappedContentPathOptionsBehavior
  *
  * Filter the list of passed in options by removing the options that have already been selected
  *
  * options:               the option picker list
  * selectedContentPath:   the path within the collection item where selections are stored
  */

// UUID option to be added to the options list
// This will allow users to add UUIDs to update existing forms
const uuidOption = {
  _created: 0,
  title: 'UUID',
  fieldType: 'uuid',
  contentPath: 'id'
};
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions) => {
  // all available options
  const options = await evaluateSource(source.options, content, parentContentPath, transientContext, nativeFunctions);

  // path to selections already made
  const selectedContentPath = await evaluateSource(source.selectedContentPath, content, parentContentPath, transientContext, nativeFunctions);
  const newOptions = {};

  // retrieve all the selected options - then winnow it down to just the keys
  const selectedOptions = getContentValues(selectedContentPath, content);
  const selectedOptionKeys = selectedOptions.map(option => Object.keys(option)[0]);

  // only pass on the options that don't exist in the selected keys array
  // processing options coming from server and also adding the UUID option
  const mergedOptions = _objectSpread({
    id: uuidOption
  }, options);
  Object.keys(mergedOptions || {}).forEach(optionKey => {
    if (!selectedOptionKeys.includes(optionKey)) {
      newOptions[optionKey] = mergedOptions[optionKey];
    }
  });
  return newOptions;
};
export default {
  evaluate
};